import { render } from "./OurProject.vue?vue&type=template&id=4d5b3a54"
import script from "./OurProject.vue?vue&type=script&lang=js"
export * from "./OurProject.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__